import { useCallback, useEffect, useRef, useState } from "react";

export function useInfiniteScroll<T>(items: T[], pageSize = 24) {
  const [visibleCount, setVisibleCount] = useState(pageSize);
  const observerRef = useRef<IntersectionObserver | null>(null);

  const sentinelRef = useCallback(
    (el: HTMLElement | null) => {
      observerRef.current?.disconnect();
      if (!el) return;
      const io = new IntersectionObserver(
        ([entry]) => {
          if (entry?.isIntersecting) {
            setVisibleCount((c) => c + pageSize);
          }
        },
        { threshold: 0.1 },
      );
      io.observe(el);
      observerRef.current = io;
    },
    [pageSize],
  );

  // biome-ignore lint/correctness/useExhaustiveDependencies: reset when list reference changes
  useEffect(() => {
    setVisibleCount(pageSize);
  }, [items, pageSize]);

  return {
    renderedItems: items.slice(0, visibleCount),
    hasMore: visibleCount < items.length,
    sentinelRef,
  };
}
